document.addEventListener("DOMContentLoaded", function() {
  // Evita doppia inizializzazione (fondamentale in Shopify)
  if (window.sliderInitialized) return;
  window.sliderInitialized = true;

  // Verifica che GSAP sia caricato
  if (typeof gsap === "undefined") {
    console.error("GSAP non è caricato. Slider non inizializzato.");
    return;
  }

  var active = 3;
  var mncircles = document.querySelectorAll(".mncircle");
  var second = document.querySelectorAll(".second");
  var slideImages = document.querySelectorAll(".slide-image");
  var tabs = document.querySelectorAll("#content > div");
  var stripes = document.querySelectorAll(".stripe");
  var container = document.getElementById("container");
  var autoplayInterval;
  var inactivityTimeout;
  var isAutoplayActive = true;

  // Verifica che il container esista
  if (!container) {
    console.error("Container non trovato. Slider non inizializzato.");
    return;
  }

  // Verifica che esistano le immagini dello slider
  if (!slideImages || slideImages.length === 0) {
    console.error("Nessuna slide-image trovata. Slider non inizializzato.");
    return;
  }

  // Assicura che l'indice attivo sia valido
  if (active > slideImages.length) {
    active = 1;
  }
  
  // Touch events per mobile
  var touchStartX = 0;
  var touchEndX = 0;
  var touchStartY = 0;
  var touchEndY = 0;

  // Funzione per controllare se siamo su mobile
  function isMobile() {
    return window.innerWidth <= 767;
  }

  function showSlide(slideNumber) {
    if (!slideImages || slideImages.length === 0) return;
    if (slideNumber < 1 || slideNumber > slideImages.length) return;

    slideImages.forEach(function(img) {
      gsap.to(img, {
        opacity: 0,
        duration: 0.5,
        ease: "power2.out"
      });
    });
    gsap.to(slideImages[slideNumber - 1], {
      opacity: 1,
      duration: 0.8,
      ease: "power2.in"
    });
  }

  function showTab(tabNumber) {
    if (!tabs || tabs.length === 0) return;
    if (tabNumber < 1 || tabNumber > tabs.length) return;

    tabs.forEach(function(tab) {
      tab.classList.remove("active");
    });
    if (tabs[tabNumber - 1]) {
      tabs[tabNumber - 1].classList.add("active");
    }
  }

  function changeSlide(index) {
    if (!slideImages || slideImages.length === 0) return;
    if (index < 0 || index >= slideImages.length) return;

    active = index + 1;
    
    // Non ruotare su mobile
    if (!isMobile()) {
      gsap.to("#circle", {
        rotate: 0,
        ease: Back.easeInOut,
        duration: 1,
      });
      
      // Identifica le strisce che devono saltare e quelle che si muovono normalmente
      var jumpingStripes = [];
      var normalStripes = [];
      
      stripes.forEach(function(stripe, i) {
        var relativePos = i - index;
        
        // Calcola la posizione precedente per rilevare i salti circolari
        var currentTransform = stripe.style.transform;
        var currentRotation = 0;
        if (currentTransform) {
          var match = currentTransform.match(/rotate\(([^)]+)deg\)/);
          if (match) {
            currentRotation = parseFloat(match[1]);
          }
        }
        
        // Gestione circolare: se la posizione relativa è fuori range, avvolgi
        if (relativePos < -2) {
          relativePos += stripes.length;
        } else if (relativePos > 4) {
          relativePos -= stripes.length;
        }
        
        var rotation = relativePos * 10;
        var rotationDiff = Math.abs(rotation - currentRotation);
        
        if (rotationDiff >= 40) {
          jumpingStripes.push({
            stripe: stripe,
            index: i,
            currentRotation: currentRotation,
            targetRotation: rotation
          });
        } else {
          normalStripes.push({
            stripe: stripe,
            targetRotation: rotation
          });
        }
      });
      
      // Applica le animazioni normali immediatamente
      normalStripes.forEach(function(item) {
        item.stripe.style.transition = "transform 0.6s ease, opacity 0.3s ease";
        item.stripe.style.transform = "translate(0, -50%) rotate(" + item.targetRotation + "deg)";
      });
      
      // Applica le animazioni con salto in sequenza
      jumpingStripes.forEach(function(item, jumpIndex) {
        var stripe = item.stripe;
        var currentRotation = item.currentRotation;
        var rotation = item.targetRotation;
        
        // Calcola una rotazione intermedia nella direzione del movimento
        var rotationDirection = rotation > currentRotation ? -1 : 1;
        var intermediateRotation = currentRotation + (rotationDirection * 15);
        
        // Continua la rotazione nella direzione corretta mentre scompare
        stripe.style.transition = "transform 0.6s ease, opacity 0.3s ease";
        stripe.style.transform = "translate(0, -50%) rotate(" + intermediateRotation + "deg)";
        
        // Fai fade out continuando la rotazione
        gsap.to(stripe, {
          opacity: 0,
          duration: 0.3,
          onComplete: (function(s, rot, delay) {
            return function() {
              // Sposta istantaneamente nella nuova posizione
              s.style.transition = "none";
              s.style.transform = "translate(0, -50%) rotate(" + rot + "deg)";
              
              // Riattiva la transizione e mostra con fade in dopo un delay
              setTimeout(function() {
                s.style.transition = "transform 0.6s ease, opacity 0.3s ease";
                gsap.to(s, {
                  opacity: 1,
                  duration: 0.3
                });
              }, 350 + (delay * 150));
            };
          })(stripe, rotation, jumpIndex)
        });
      });
    }
    
    greyout();
    
    if (mncircles && mncircles[index]) {
      gsap.to(mncircles[index], {
        opacity: 0.5,
      });
    }
    
    if (second && second[index]) {
      gsap.to(second[index], {
        opacity: 1,
      });
    }
    
    // Assicura che le strisce che non saltano mantengano opacity 1
    if (!isMobile() && stripes && stripes.length > 0) {
      stripes.forEach(function(stripe, i) {
        if (stripe.style.opacity !== "0") {
          stripe.style.opacity = "1";
        }
      });
    }
    
    // Gestione stripe attive per mobile
    if (stripes && stripes.length > 0) {
      stripes.forEach(function(stripe) {
        stripe.classList.remove("active");
      });
      if (stripes[index]) {
        stripes[index].classList.add("active");
      }
    }
    
    showSlide(index + 1);
    showTab(index + 1);
  }

  function startAutoplay() {
    if (!slideImages || slideImages.length === 0) return;
    if (!mncircles || mncircles.length === 0) return;

    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }

    autoplayInterval = setInterval(function() {
      var nextIndex = active % mncircles.length;
      changeSlide(nextIndex);
    }, 5000);
  }

  function stopAutoplay() {
    if (isAutoplayActive && autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
      isAutoplayActive = false;
    }
  }

  function resetAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
    startAutoplay();
  }

  function resetInactivityTimer() {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(function() {
      if (!isAutoplayActive) {
        isAutoplayActive = true;
        startAutoplay();
      }
    }, 5000); // Riattiva dopo 5 secondi di inattività
  }

  // Ferma autoplay su qualsiasi interazione
  document.addEventListener("click", function(e) {
    if (e.target.closest(".mncircle") || e.target.closest(".second") || e.target.closest("#content")) {
      stopAutoplay();
      resetInactivityTimer();
    }
  });

  document.addEventListener("mousemove", function(e) {
    if (e.target.closest("#container") || e.target.closest("#content") || e.target.closest("#panel")) {
      stopAutoplay();
      resetInactivityTimer();
    }
  });

  if (mncircles && mncircles[active - 1]) {
    gsap.to(mncircles[active - 1], {
      opacity: 0.5,
    });
  }

  if (second && second[active - 1]) {
    gsap.to(second[active - 1], {
      opacity: 1, 
    });
  }

  // Imposta la stripe iniziale come attiva
  if (stripes && stripes[active - 1]) {
    stripes[active - 1].classList.add("active");
  }

  // Non ruotare su mobile e posiziona le strisce iniziali
  if (!isMobile() && stripes && stripes.length > 0) {
    var circleElement = document.getElementById("circle");
    if (circleElement) {
      gsap.to("#circle", {
        rotate: 0,
        ease: Expo.easeInOut,
        duration: 2,
      });
    }
    
    // Posiziona le strisce inizialmente
    stripes.forEach(function(stripe, i) {
      var relativePos = i - (active - 1);
      
      if (relativePos < -2) {
        relativePos += stripes.length;
      } else if (relativePos > 4) {
        relativePos -= stripes.length;
      }
      
      var rotation = relativePos * 10;
      stripe.style.transition = "transform 0.6s ease, opacity 0.3s ease";
      stripe.style.transform = "translate(0, -50%) rotate(" + rotation + "deg)";
      stripe.style.opacity = "1";
    });
  }


  slideImages.forEach(function(img, i) {
    if (i === active - 1) {
      img.style.opacity = "1";
    } else {
      img.style.opacity = "0";
    }
  });

  // Imposta l'immagine iniziale
  showSlide(active);
  showTab(active);

  // Avvia autoplay
  startAutoplay();

  if (mncircles && mncircles.length > 0) {
    mncircles.forEach(function (val, index) {
      val.addEventListener("click", function () {
        changeSlide(index);
      });
    });
  }

  if (second && second.length > 0) {
    second.forEach(function (val, index) {
      val.addEventListener("click", function () {
        changeSlide(index);
      });
    });
  }

  function greyout() {
    if (mncircles && mncircles.length > 0) {
      gsap.to(mncircles, {
        opacity: 0.2,
      });
    }
    if (second && second.length > 0) {
      gsap.to(second, {
        opacity: 0.4,
      });
    }
  }

  // Gestione swipe per mobile
  container.addEventListener("touchstart", function(e) {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
  }, { passive: true });

  container.addEventListener("touchend", function(e) {
    touchEndX = e.changedTouches[0].screenX;
    touchEndY = e.changedTouches[0].screenY;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    var diffX = touchStartX - touchEndX;
    var diffY = touchStartY - touchEndY;
    
    // Verifica che sia uno swipe orizzontale (e non verticale)
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
      stopAutoplay();
      resetInactivityTimer();
      
      if (diffX > 0) {
        // Swipe a sinistra - vai alla slide successiva
        var nextIndex = active % mncircles.length;
        changeSlide(nextIndex);
      } else {
        // Swipe a destra - vai alla slide precedente
        var prevIndex = (active - 2 + mncircles.length) % mncircles.length;
        changeSlide(prevIndex);
      }
    }
  }
}); 